import { render, staticRenderFns } from "./Register2.vue?vue&type=template&id=8c40bd74&scoped=true&"
import script from "./Register2.vue?vue&type=script&lang=js&"
export * from "./Register2.vue?vue&type=script&lang=js&"
import style0 from "./Register2.vue?vue&type=style&index=0&id=8c40bd74&prod&lang=css&"
import style1 from "./Register2.vue?vue&type=style&index=1&id=8c40bd74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c40bd74",
  null
  
)

export default component.exports